module.exports = __webpack_public_path__ + "static/media/Badge_SvgExpertCategoriel_Dermatologie.13fe3779.png";